export default "__VITE_ASSET__BMMkjpG9__"